import React from 'react';
import { assignedPhonePresentation } from './assignedUserPhone';

export function TaskUserLabel({ user, t }) {
    if (!user?.fullname) {
        return <>-</>;
    }

    if (user.former_member) {
        return (
            <>
                {user.fullname}
                {' '}
                <span className="badge badge-secondary">{t('users.former_member_badge')}</span>
            </>
        );
    }

    return <>{user.fullname}</>;
}

export function TaskUserPhone({ user }) {
    const phone = assignedPhonePresentation(user);
    if (!phone)
        return null;

    return (
        <>
            <a
                className="task-user-phone-link no-print"
                href={phone.uri}
                title={phone.display}
                aria-label={phone.display}
                onClick={(event) => event.stopPropagation()}
            >
                <i className="fa fa-mobile-alt" aria-hidden="true" />
            </a>
            <span className="task-user-phone print-only">{phone.display}</span>
        </>
    );
}
